<template>
    <div class="collapse-fiona-item-content" v-show="currentItemIndex == Number(index)">
        <slot></slot>
    </div>
</template>

<script>
	export default {
        props: {
            index: String,
        },
        data() {
            return {
                currentItemIndex: 0,
            };
        },
        mounted() {
            this.$eventHub.$on('updateTabItemIndex', (index, sender) => {
                if (this.$parent._uid === sender._uid) {
					this.currentItemIndex = index;

					if (Number(this.index) !== Number(index)) return;

					const images = this.$el.querySelectorAll('picture > img');

					if (images.length === 0) return;
				}
            });
        }
    }
</script>
